@if (showSpinner) {
<section class="resignation-skeleton" >
  <div class="skeleton-header"></div>
  <div class="skeleton-subheader"></div>
  <div class="skeleton-list">
    @for (item of [1,2,3,4]; track item) {
    <div class="skeleton-card">
      <div class="skeleton-row">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-line-group">
          <div class="skeleton-line lg"></div>
          <div class="skeleton-line sm"></div>
        </div>
        <div class="skeleton-pill"></div>
      </div>
      <div class="skeleton-grid">
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
      </div>
      <div class="skeleton-paragraph">
        <div class="skeleton-line"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line sm"></div>
      </div>
    </div>
    }
  </div>
</section>
}



@if (!showSpinner) {
<main class="content-wrapper" [ngClass]="{ 'dark-mode': selectedMode === 'dark' }">
  @if (isavailablefeature('isView')) {
  <div class="container-fluid mb-4">
    <div class="page-header" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
      <div>
        <h3 class="page-title">All Resignations</h3>
        <p class="page-subtitle">Manage and review employee resignations</p>
      </div>
      <button type="button" class="btn btn-terminate-top" data-toggle="modal" data-target="#terminateEmployeeModal"
        (click)="openTerminationModal()">
        Terminate Employee
      </button>
    </div>

   

    <div class="resignation-table-wrapper">
      <div class="stats-grid">
        <div class="stat-card stat-total">
          <div class="stat-icon-box">
            <svg class="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="2" x2="12" y2="22"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">Total</p>
            <h3 class="stat-value">{{ stats.total }}</h3>
          </div>
        </div>

        <div class="stat-card stat-pending">
          <div class="stat-icon-box">
            <svg class="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="13" r="8"></circle>
              <path d="M12 9v4"></path>
              <path d="M9 12h6"></path>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">Pending</p>
            <h3 class="stat-value">{{ stats.pending }}</h3>
          </div>
        </div>

        <div class="stat-card stat-accepted">
          <div class="stat-icon-box">
            <svg class="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">Accepted</p>
            <h3 class="stat-value">{{ stats.accepted }}</h3>
          </div>
        </div>

        <div class="stat-card stat-rejected">
          <div class="stat-icon-box">
            <svg class="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">Rejected</p>
            <h3 class="stat-value">{{ stats.rejected }}</h3>
          </div>
        </div>

        <div class="stat-card stat-month">
          <div class="stat-icon-box">
            <svg class="stat-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          </div>
          <div class="stat-content">
            <p class="stat-label">This Month</p>
            <h3 class="stat-value">{{ stats.thisMonth }}</h3>
          </div>
        </div>
      </div>

      <div class="resignation-list">
        @for (user of usersList; track user) {
        <article class="resign-card"
          [ngClass]="{ 'dark-backround': selectedMode === 'dark', 'status-pending-highlight': user.status === 'pending' }">
          <div class="card-header">
            <div class="profile-section">
              <img class="profile-avatar" src="{{ user.user_detail.profile_image }}" alt="" />
              <div class="profile-info">
                <h5>{{ user.user_detail.first_name }} {{ user.user_detail.last_name }}</h5>
                <p class="email-text">{{ user.user_detail.email }}</p>
                <span class="type-badge" [ngClass]="getTypeClass(user)">{{ getTypeLabel(user) }}</span>
              </div>
            </div>
            <span class="status-badge" [ngClass]="{
                  'status-accepted': user.status === 'accepted',
                  'status-rejected': user.status === 'rejected',
                  'status-pending': user.status === 'pending'
                }">
              {{ user.status }}
            </span>
          </div>

          <div class="card-meta">
            <div class="meta-row">
              <div class="meta-cell">
                <span class="meta-label">🧾 Designation</span>
                <strong>{{ user.subject || user.designation }}</strong>
              </div>
              <div class="meta-cell">
                <span class="meta-label">🏢 Employment Type</span>
                <strong>{{ user.employment_status }}</strong>
              </div>
              <div class="meta-cell">
                <span class="meta-label">📅 Apply Date</span>
                <strong>{{ user.resign_date | date : 'd MMM, y' }}</strong>
              </div>
              <div class="meta-cell">
                <span class="meta-label">⏳ Last Working Date</span>
                <strong>{{ user.last_working_date | date : 'd MMM, y' }}</strong>
              </div>
            </div>
          </div>

          <div class="card-letter">
            <details class="resign-details" [open]="user.status === 'pending'">
              <summary><span class="letter-icon">📝</span> {{ getTypeLabel(user) }} Message</summary>
              <div class="letter-content">
                {{ user.resign_explanation }}
                @if (user.additional_notes) {
                <hr />
                <strong>Additional Notes:</strong>
                <div>{{ user.additional_notes }}</div>
                }
              </div>
            </details>
          </div>

          @if (user.status === 'pending') {
          <div class="card-actions">
            @if (isavailablefeature('isAccept')) {
            <button (click)="openAcceptModal(user)" data-toggle="modal" data-target="#acceptResignationModal"
              class="btn btn-success" type="button">
              <span>✓</span> Accept
            </button>
            }
            @if (isavailablefeature('isReject')) {
            <button (click)="updateRejectStatus(user)" class="btn btn-danger" type="button">
              <span>✕</span> Reject
            </button>
            }
          </div>
          }
        </article>
        }
      </div>
    </div>

     @if (!showSpinner && usersList.length === 0) {
    <div class="empty-state" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="empty-icon">📄</div>
      <h5>No resignations found</h5>
      <p>Once employees submit resignations, they will appear here.</p>
    </div>
    }
  </div>
  }
</main>

}



<!-- Accept Resignation Modal -->
<div class="modal fade custom-modal" id="acceptResignationModal" tabindex="-1" role="dialog"
  aria-labelledby="acceptResignationModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg rounded-4">

      <!-- Header -->
      <div class="modal-header border-bottom-0 pb-0 pt-4 px-4 d-flex justify-content-between align-items-center">
        <h5 class="modal-title fw-bold text-dark d-flex align-items-center gap-2" id="acceptResignationModalLabel">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          Accept Resignation
        </h5>
        <button type="button" class="close text-secondary" data-dismiss="modal" aria-label="Close"
          style="font-size: 1.5rem;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body px-4 py-4 input-bg">
        <p class="text-muted mb-4 fs-6">
          You are about to accept the resignation for
          <strong class="text-dark">{{ selectedResignation?.user_detail?.first_name }} {{
            selectedResignation?.user_detail?.last_name }}</strong>.
          Please confirm their last working day.
        </p>

        <!-- Options Container -->
        <div class="d-flex flex-column gap-3">

          <!-- Option 1: Keep System Date -->
          <label
            class="d-flex align-items-start justify-content-between gap-3 p-3 border rounded-3 cursor-pointer option-card transition-all"
            [class.border-success]="acceptDateOption === 'same'" [class.bg-light]="acceptDateOption === 'same'"
            [class.shadow-sm]="acceptDateOption === 'same'">
            <div>
              <span class="d-block fw-semibold text-dark mb-1 fs-6">Accept as applied</span>
              <span class="text-muted">Keep the system-generated Last Working Day:
                <strong class="text-dark ms-1 bg-light px-2 py-1 rounded">{{ selectedResignation?.last_working_date |
                  date: 'd MMM, y' }}</strong>
              </span>
            </div>
            <input type="radio" class="custom-radio mt-1" style="flex-shrink: 0;" name="acceptDateOption" value="same"
              [(ngModel)]="acceptDateOption">
          </label>

          <!-- Option 2: Change Date -->
          <label
            class="d-flex align-items-start justify-content-between gap-3 p-3 border rounded-3 cursor-pointer option-card transition-all"
            [class.border-success]="acceptDateOption === 'change'" [class.bg-light]="acceptDateOption === 'change'"
            [class.shadow-sm]="acceptDateOption === 'change'">
            <div class="w-100 pr-3">
              <span class="d-block fw-semibold text-dark mb-1 fs-6">Change last working date</span>
              <span class="text-muted d-block mb-3">Manually select a different final working day for the
                employee.</span>

              <!-- Date Picker Input -->
              <div class="mt-2 position-relative date-input-wrapper overflow-hidden"
                [class.show]="acceptDateOption === 'change'">
                <input type="date" class="form-control form-control-lg border-secondary-subtle"
                  [(ngModel)]="customLastWorkingDate" [disabled]="acceptDateOption !== 'change'">
              </div>
            </div>
            <input type="radio" class="custom-radio mt-1" style="flex-shrink: 0;" name="acceptDateOption" value="change"
              [(ngModel)]="acceptDateOption">
          </label>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer border-top-0 pt-0 pb-4 px-4 d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-light px-4 py-2 border" data-dismiss="modal">Cancel</button>
        <button type="button"
          class="btn btn-confirm-accept px-4 py-2 text-white shadow-sm d-flex align-items-center gap-2"
          (click)="confirmAcceptResignation()" [disabled]="acceptDateOption === 'change' && !customLastWorkingDate">
          Confirm Acceptance
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Terminate Employee Modal -->
<div class="modal fade custom-modal" id="terminateEmployeeModal" tabindex="-1" role="dialog"
  aria-labelledby="terminateEmployeeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered termination-modal-dialog">
    <div class="modal-content border-0 shadow-lg rounded-4 termination-modal-content">

      <div class="modal-header border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center termination-header">
        <div>
          <h5 class="modal-title fw-bold text-dark mb-1" id="terminateEmployeeModalLabel">Terminate Employee</h5>
          <p class="termination-subtitle mb-0">Create an official termination request with complete details.</p>
        </div>
        <button type="button" class="close text-secondary" data-dismiss="modal" aria-label="Close"
          style="font-size: 1.5rem;">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body px-4 py-4 input-bg termination-body">
        <div class="termination-form-grid">
          <div class="form-group mb-3 termination-field termination-field-wide" [class.dropdown-open]="terminationDropdownOpen">
          <label class="font-weight-600 termination-label">Employee <span class="text-danger">*</span></label>
            <div class="custom-employee-dropdown">
              <button type="button" class="employee-dropdown-trigger" (click)="toggleTerminationDropdown()"
                [attr.aria-expanded]="terminationDropdownOpen">
                <span class="employee-dropdown-label">{{ selectedTerminationEmployeeLabel }}</span>
                <span class="employee-dropdown-caret" [class.open]="terminationDropdownOpen"></span>
              </button>

              @if (terminationDropdownOpen) {
              <div class="employee-dropdown-panel">
                <div class="employee-search-wrap">
                  <input type="text" class="employee-search-input" placeholder="Search by name or email"
                    [(ngModel)]="terminationEmployeeSearch" name="termination_employee_search" />
                </div>

                <div class="employee-options-list">
                  @if (filteredTerminationEmployees.length === 0) {
                  <div class="employee-option-empty">No employee found</div>
                  }
                  @for (employee of filteredTerminationEmployees; track employee.id) {
                  <button type="button" class="employee-option-item" (click)="selectTerminationEmployee(employee)">
                    <span class="employee-option-name">{{ employee.first_name }} {{ employee.last_name }}</span>
                    <span class="employee-option-email">{{ employee.email }}</span>
                  </button>
                  }
                </div>
              </div>
              }
          </div>
        </div>

        <div class="form-group mb-3 termination-field">
          <label class="font-weight-600 termination-label">Subject / Title <span class="text-danger">*</span></label>
          <input type="text" class="form-control termination-input" [(ngModel)]="terminationForm.subject" name="termination_subject"
            placeholder="Enter termination subject" />
        </div>

        <div class="form-group mb-3 termination-field">
          <label class="font-weight-600 termination-label">Last Working Day <span class="text-danger">*</span></label>
          <input type="date" class="form-control termination-input" [(ngModel)]="terminationForm.last_working_date"
            name="termination_last_working_day" />
        </div>

        <div class="form-group mb-3 termination-field termination-field-wide">
          <label class="font-weight-600 termination-label">Termination Reason / Message <span class="text-danger">*</span></label>
          <textarea rows="4" class="form-control termination-input" [(ngModel)]="terminationForm.resign_explanation"
            name="termination_reason" placeholder="Enter reason/message"></textarea>
        </div>

        <div class="form-group mb-0 termination-field termination-field-wide">
          <label class="font-weight-600 termination-label">Additional Notes (optional)</label>
          <textarea rows="3" class="form-control termination-input" [(ngModel)]="terminationForm.additional_notes"
            name="termination_additional_notes" placeholder="Additional details (optional)"></textarea>
        </div>
        </div>
      </div>

      <div class="modal-footer border-top-0 pt-2 pb-4 px-4 d-flex justify-content-end gap-2 termination-footer">
        <button type="button" class="btn btn-light px-4 py-2 border" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger px-4 py-2 termination-submit" (click)="submitTermination()"
          [disabled]="terminationSubmitting">
          {{ terminationSubmitting ? 'Submitting Termination Request...' : 'Submit Termination' }}
        </button>
      </div>
    </div>
  </div>
</div>